export const VIEW_ISOTOPE_ITEM_CLASS = 'isotope-item';